import { gql } from '@apollo/client';

export const finalizeRegistrationMutation = gql`
    mutation FinalizeRegistration {
        updateUser(data: { registrationStage: Finished }) {
            id
            registrationStage
        }
    }
`;
